import { IDanhBaSinhVienActionTypes } from "../../action-types/category/IDanhBaSinhVienActionTypes";
import { IDanhBaSinhVienReducer } from "../../reducer-model/category/IDanhBaSinhVienReducer";
import { eReducerStatusBase } from "../../reducer-model/eReducerStatusBase";
const iniState: IDanhBaSinhVienReducer = {
  status: eReducerStatusBase.is_not_initialization,
  sinhViens: [],
  displayMode: window.innerWidth >= 1400 ? "full" : "popup",
  sinhVienSelectedIds: [],
  dotNhapHoc: 0,
  trangThaiHocs: [0],
  dot: 0,
};
export const danhBaSinhVienReducer = (
  state: IDanhBaSinhVienReducer = iniState,
  action: IDanhBaSinhVienActionTypes,
): IDanhBaSinhVienReducer => {
  switch (action.type) {
    case "DANH_BA_SINH_VIEN_CHANGE_DISPLAY_MODE":
      return {
        ...state,
        displayMode: action.payload,
      };
    case "DANH_BA_SINH_VIEN_CHANGE_FOCUS_TREEVIEW_VALUE":
      return {
        ...state,
        focusedValue: action.payload,
        sinhVienSelectedIds: [],
      };
    case "DANH_BA_SINH_VIEN_LOAD_HOCSINH_START":
      return {
        ...state,
        status: eReducerStatusBase.is_loading,
        sinhVienSelectedIds: [],
      };
    case "DANH_BA_SINH_VIEN_LOAD_HOCSINH_SUCCESS":
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
        sinhViens: action.payload,
      };
    case "DANH_BA_SINH_VIEN_LOAD_HOCSINH_ERRR":
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
      };
    case "DANH_BA_SINH_VIEN_CHANGE_SINHVIEN_SELECTED_IDS":
      return {
        ...state,
        sinhVienSelectedIds: action.payload,
      };
    default:
      return state;
  }
};
